import React, { Component, useState, useEffect, useMemo } from 'react';
import GoogleMapReact from 'google-map-react';
import red from "./images/red.png";
import orange from "./images/orange.png";
import green from "./images/green.png";
import yellow from "./images/yellow.png";

let icons = { red, green, orange, yellow };

const MarkerPin = ({ color }) => <img src={icons[color]}></img>;
const GoogleMap = ({ locations }) => {
  // calculate center of all the locations.
  const def = {
    center: {
      lat: 19.41423,
      lng: 76.9
    },
    zoom: 9
  };
  if (!locations) { locations = []; }

  // Remove google dev warning.
  useEffect(() => {
    setTimeout(() => {
      let chil = document.getElementById("maparea");
      if (chil) {
        let chi = chil.children;
        if (chi.length == 1) {
          try { chi[0].children[0].children[1].style.display = "none"; }
          catch (err) {
            setTimeout(() => {
              try {
                chi[0].children[0].children[1].style.display = "none";
              } catch (err) {
              }
            }, 4000)
          }
        }
      }
    }, 2000);
  }, [])

  return (
    // <div>f</div>
    <GoogleMapReact
      bootstrapURLKeys={{ key: 'AIzaSyBKvNqYcA2ZpUhol7g0eBk4SE5BvhB5ryI' }}
      defaultCenter={def.center}
      defaultZoom={def.zoom}
    >
      {locations.map(({ latitude, longitude, pincolor }, idx) => {
        return (
          <MarkerPin
            key={idx}
            color={pincolor}
            lat={latitude}
            lng={longitude}
          />
        )
      })}
    </GoogleMapReact>
  );
}


export default GoogleMap;